import emailjs from "@emailjs/browser";
import {
     collection,
    query,
    where,
    getDocs,
    doc,
    setDoc,
    serverTimestamp,
    getDoc
 } from "firebase/firestore";
 import { db } from "../firebase";
import { error } from "three";

 const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
 const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
 const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

 export async function sendOtp(email){
        const q = query(
            collection(db,"users"),
            where("email","==",email)
        );

        const snapshot = await getDocs(q);

        if(snapshot.empty)
        {
            throw new Error("User not found");
        }

        const otp = Math.floor(
            100000 + Math.random() * 900000
        ).toString();

        const response = await emailjs.send(
            serviceId,
            templateId,
            {
                to_email:email,
                otp:otp
            },
            {
                publicKey:publicKey
            }
        );

        await setDoc(doc(db,"otp",email), {
            email,
            otp,
            createdAt: serverTimestamp(),
            expiresAt : Date.now() + 5 * 60 * 1000
        });

        return true;
 }

 export async function getUser(email){

    const userRef = collection(db,"users");
    const q = query(
        userRef,
        where("email", "==" ,email)
    );

    const docs = await getDocs(q);

    const userDoc = docs.docs[0];
    if(userDoc.empty)
    {
        throw new Error("User Not Found");
    }
    return {
        id:userDoc.Id,
        ...userDoc.data()
    };
 }